import { Component, OnInit } from '@angular/core';
import { CommonUtilities } from 'src/assets/js/common-utilities';
// import * as XLSX from 'xlsx';
@Component({
  selector: 'app-c-stockkeepingunit',
  templateUrl: './c-stockkeepingunit.component.html',
  styleUrls: ['./c-stockkeepingunit.component.css']
})
export class CStockkeepingunitComponent implements OnInit {
  agentListGrid:any[]
  VolumeList:any[]
  selectedtab: number = 0;
  displayBasic: boolean;
  _Uom:any[]
  _Basedon:any[]
  willDownload
  constructor(private utility:CommonUtilities) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this._Uom = [
      {uomid:'1',uomname:'cm'},
      {uomid:'2',uomname:'inch'},
      {uomid:'3',uomname:'mm'}
      
    ]
    this._Basedon = [
      {id:'1',name:'6'},
      {id:'2',name:'8'},
      {id:'3',name:'10'}
      
    ]
    this.agentListGrid=[
    {agentNo:'1', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'2', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'3', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'4', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'5', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'6', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'7', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'8', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'9', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'9', agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'10',agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'11',agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'12',agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'13',agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    {agentNo:'14',agentName:'VACCUM WATER BOTTLE',fatherName:'cm',mobileNo:'5',emailId:'5',doorNo:'5, INDIRA SALAI, THIRUKALLIMEDU, KANCHIPURAM, TAMILNADU - 631502',city:'KANCHEEPURAM',state:'Tamil Nadu',pincode:'5,5,5',eduQual:'Education Qualification',locInterest:''},
    ];
    this.VolumeList=[
      {sno:'1',hub:'Trichy',quantity:'10'},
      {sno:'2',hub:'Tanjore',quantity:'10'},
      {sno:'3',hub:'Chennai',quantity:'10'},
      {sno:'4',hub:'Madurai',quantity:'10'},
      {sno:'5',hub:'Vellore',quantity:'10'},
      {sno:'6',hub:'Karur',quantity:'10'},
      {sno:'7',hub:'Erode',quantity:'10'},
    ]
  }
  showBasicDialog(){
    this.displayBasic = true;
  }


//   addfile(event)     
//   {    
//   this.file= event.target.files[0];     
//   let fileReader = new FileReader();    
//   fileReader.readAsArrayBuffer(this.file);     
//   fileReader.onload = (e) => {    
//       this.arrayBuffer = fileReader.result;    
//       var data = new Uint8Array(this.arrayBuffer);    
//       var arr = new Array();    
//       for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);    
//       var bstr = arr.join("");    
//       var workbook = XLSX.read(bstr, {type:"binary"});    
//       var first_sheet_name = workbook.SheetNames[0];    
//       var worksheet = workbook.Sheets[first_sheet_name];    
//       console.log(XLSX.utils.sheet_to_json(worksheet,{raw:true}));    
//         var arraylist = XLSX.utils.sheet_to_json(worksheet,{raw:true});     
//             this.filelist = [];    
//             console.log(this.filelist)    
    
//   }    
// } 
}
